module.exports = __webpack_public_path__ + "img/Sulaiman.ab47e02e.png";